module.exports = __webpack_public_path__ + "static/img/open_imgs.7e83fbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/open_imgs.png
// module id = 80
// module chunks = 2